import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconHelp.module.css';
const SIZE_SMALL = 'small';

const IconHelp = props => {
  const { className, rootClassName, size, ...rest } = props;
  const classes = classNames(css.root);

  return (
    <svg className={classes} style={{fill:'none !important',width: '25px !important'}} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" {...rest}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
    </svg>
  );
};

const { string } = PropTypes;

IconHelp.defaultProps = {
  className: null,
  rootClassName: null,
};

IconHelp.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconHelp;
